import { Injectable, NgModule, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';

@Injectable()

@NgModule({
  imports: [MatDialogModule, BrowserAnimationsModule, FormsModule]
})

export class MasterService {
  myAppUrl: string = "";
  header: Headers;

  constructor(private _http: Http, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  //** Plan
  getPlans(isNotALL: Boolean) {
    return this._http.get(this.myAppUrl + 'api/master/GetListPlans/' + isNotALL, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getPlanById(id: number) {
    return this._http.get(this.myAppUrl + 'api/master/GetPlanById/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getPlansForDropDown() {
    return this._http.get(this.myAppUrl + 'api/master/GetListPlansForDropDown', {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addPlan(data) {
    return this._http.post(this.myAppUrl + 'api/master/AddPlan', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  updatePlan(data) {
    return this._http.put(this.myAppUrl + 'api/master/UpdatePlan', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deletePlan(data) {
    return this._http.delete(this.myAppUrl + "api/master/DeletePlan/" + data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //** Payment
  getPayments(isNotALL: Boolean) {
    return this._http.get(this.myAppUrl + 'api/master/GetListPayments/' + isNotALL, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getPaymentById(id: number) {
    return this._http.get(this.myAppUrl + 'api/master/GetPaymentById/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getPaymentsForDropDown() {
    return this._http.get(this.myAppUrl + 'api/master/GetListPaymentsForDropDown', {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addPayment(data) {
    return this._http.post(this.myAppUrl + 'api/master/AddPayment', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  updatePayment(data) {
    return this._http.put(this.myAppUrl + 'api/master/UpdatePayment', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deletePayment(data) {
    return this._http.delete(this.myAppUrl + "api/master/DeletePayment/" + data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //** Device
  getDevices(isNotALL: Boolean) {
    return this._http.get(this.myAppUrl + 'api/master/GetListDevices/' + isNotALL, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getDevicesExcludeDisposed(id: number) {
    return this._http.get(this.myAppUrl + 'api/master/GetDevicesExcludeDisposed/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getDeviceById(id: number) {
    return this._http.get(this.myAppUrl + 'api/master/GetDeviceById/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getDevicesDropDownByCustomerId(id: number) {
    return this._http.get(this.myAppUrl + 'api/master/GetDevicesDropDownByCustomerId/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  } 

  getDevicesDropDownByCustomerName(name: string) {
    return this._http.get(this.myAppUrl + 'api/master/GetDevicesDropDownByCustomerName/' + name.replace(/ /g, '').replace(/　/g, '').replace(/_/g, ''), {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getDevicesForDropDown() {
    return this._http.get(this.myAppUrl + 'api/master/GetListDevicesForDropDown', {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getListDevicesForDropDownSearchList(contract_id, mac_address) {
    return this._http.get(this.myAppUrl + 'api/master/GetListDevicesForDropDownSearchList/' + contract_id + '/' + mac_address.replace(/ /g, '').replace(/　/g, '').replace(/_/g, ''), {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getListDevicesForDropDownSearchListALL(mac_address) {
    return this._http.get(this.myAppUrl + 'api/master/GetListDevicesForDropDownSearchListALL/' + mac_address, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addDevice(data) {
    return this._http.post(this.myAppUrl + 'api/master/AddDevice', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  updateDevice(data) {
    return this._http.put(this.myAppUrl + 'api/master/UpdateDevice', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteDevice(data) {
    return this._http.delete(this.myAppUrl + "api/master/DeleteDevice/" + data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //** User
  checkAssigneUsers(data) {
    return this._http.get(this.myAppUrl + 'api/master/checkAssignedUsers/' + data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getUsers(isNotALL: Boolean) {
    return this._http.get(this.myAppUrl + 'api/master/GetListUsers/' + isNotALL, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getUserById(id: number) {
    return this._http.get(this.myAppUrl + 'api/master/GetUserById/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addUser(data) {
    return this._http.post(this.myAppUrl + 'api/master/AddUser', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  updateUser(data) {
    return this._http.put(this.myAppUrl + 'api/master/UpdateUser', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteUser(data) {
    return this._http.delete(this.myAppUrl + "api/master/DeleteUser/" + data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //** Remind
  getReminds(isNotALL: Boolean) {
    return this._http.get(this.myAppUrl + 'api/master/GetListReminds/' + isNotALL, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getRemindById(id: number) {
    return this._http.get(this.myAppUrl + 'api/master/GetRemindById/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addRemind(data) {
    return this._http.post(this.myAppUrl + 'api/master/AddRemind', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  updateRemind(data) {
    return this._http.put(this.myAppUrl + 'api/master/UpdateRemind', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteRemind(data) {
    return this._http.delete(this.myAppUrl + "api/master/DeleteRemind/" + data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //** Symptom
  getSymptoms(isNotALL: Boolean) {
    return this._http.get(this.myAppUrl + 'api/master/GetListSymptoms/' + isNotALL, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getSymptomById(id: number) {
    return this._http.get(this.myAppUrl + 'api/master/GetSymptomById/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getSymptomsForDropDown() {
    return this._http.get(this.myAppUrl + 'api/master/GetListSymptomsForDropDown', {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addSymptom(data) {
    return this._http.post(this.myAppUrl + 'api/master/AddSymptom', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  updateSymptom(data) {
    return this._http.put(this.myAppUrl + 'api/master/UpdateSymptom', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteSymptom(data) {
    return this._http.delete(this.myAppUrl + "api/master/DeleteSymptom/" + data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //** Status
  getStatuss(isNotALL: Boolean) {
    return this._http.get(this.myAppUrl + 'api/master/GetListStatuss/' + isNotALL, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getStatusById(id: number) {
    return this._http.get(this.myAppUrl + 'api/master/GetStatusById/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getStatussForDropDown() {
    return this._http.get(this.myAppUrl + 'api/master/GetListStatussForDropDown', {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addStatus(data) {
    return this._http.post(this.myAppUrl + 'api/master/AddStatus', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  updateStatus(data) {
    return this._http.put(this.myAppUrl + 'api/master/UpdateStatus', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteStatus(data) {
    return this._http.delete(this.myAppUrl + "api/master/DeleteStatus/" + data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  ////** Agent
  getAgents(isNotALL: Boolean) {
    return this._http.get(this.myAppUrl + 'api/master/GetListAgents/' + isNotALL, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getAgentById(id: number) {
    return this._http.get(this.myAppUrl + 'api/master/GetAgentById/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getListAgentsForDropDownSearchList(name: string) {
    return this._http.get(this.myAppUrl + 'api/master/GetListAgentsForDropDownSearchList/' + name.replace(/ /g, '').replace(/　/g, '').replace(/_/g, ''), {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getAgentsForDropDown() {
    return this._http.get(this.myAppUrl + 'api/master/GetListAgentsForDropDown', {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addAgent(data) {
    return this._http.post(this.myAppUrl + 'api/master/AddAgent', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  updateAgent(data) {
    return this._http.put(this.myAppUrl + 'api/master/UpdateAgent', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteAgent(data) {
    return this._http.delete(this.myAppUrl + "api/master/DeleteAgent/" + data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //** AgentPerson
  checkAgentPerson(data, index) {
    return this._http.get(this.myAppUrl + "api/master/CheckAgentPerson/" + data + "/" + index, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //getAgentPersonsByAgentNameForDropDownSearchList(name: string) {
  //  return this._http.get(this.myAppUrl + 'api/master/getAgentPersonsByAgentNameForDropDownSearchList/' + name.replace(/ /g, '').replace(/　/g, '').replace(/_/g, ''), {
  //    headers: new Headers({
  //      "Authorization": "Bearer " + localStorage.getItem("jwt"),
  //      "Content-Type": "application/json; charset=utf-8"
  //    })
  //  })
  //    .map((response: Response) => response.json())
  //    .catch(this.errorHandler);
  //}

  getAgentPersonsByNameForDropDownSearchList(name: string) {
    return this._http.get(this.myAppUrl + 'api/master/getAgentPersonsByNameForDropDownSearchList/' + name.replace(/ /g, '').replace(/　/g, '').replace(/_/g, ''), {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getAgentPersonById(id: number) {
    return this._http.get(this.myAppUrl + 'api/master/GetAgentPersonById/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getAgentPersonsByAgentId(id: number) {
    return this._http.get(this.myAppUrl + 'api/master/GetListAgentPersonsByAgentId/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getAgentPersons(isNotALL: Boolean) {
    return this._http.get(this.myAppUrl + 'api/master/GetListAgentPersons/' + isNotALL, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addAgentPerson(data) {
    return this._http.post(this.myAppUrl + 'api/master/AddAgentPerson', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  updateAgentPerson(data) {
    return this._http.put(this.myAppUrl + 'api/master/UpdateAgentPerson', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteAgentPerson(data) {
    return this._http.delete(this.myAppUrl + "api/master/DeleteAgentPerson/" + data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //** Customer
  getCustomers(isNotALL: Boolean) {
    return this._http.get(this.myAppUrl + 'api/master/GetListCustomers/' + isNotALL, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getCustomerById(id: number) {
    return this._http.get(this.myAppUrl + 'api/master/GetCustomerById/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getCustomersForDropDown() {
    return this._http.get(this.myAppUrl + 'api/master/GetListCustomersForDropDown', {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getListCustomersForDropDownSearchList(name) {
    return this._http.get(this.myAppUrl + 'api/master/GetListCustomersForDropDownSearchList/' + name.replace(/ /g, '').replace(/　/g, '').replace(/_/g, ''), {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addCustomer(data) {
    return this._http.post(this.myAppUrl + 'api/master/AddCustomerWithContract', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  updateCustomer(data) {
    return this._http.put(this.myAppUrl + 'api/master/UpdateCustomer', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteCustomer(data) {
    return this._http.delete(this.myAppUrl + "api/master/DeleteCustomer/" + data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  checkCustomer(data) {
    return this._http.get(this.myAppUrl + 'api/master/checkCustomer/' + data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //** Item
  getItems(isNotALL: Boolean) {
    return this._http.get(this.myAppUrl + 'api/master/GetListItems/' + isNotALL, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getItemById(id: number) {
    return this._http.get(this.myAppUrl + 'api/master/GetItemById/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getItemsForDropDown() {
    return this._http.get(this.myAppUrl + 'api/master/GetListItemsForDropDown', {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addItem(data) {
    return this._http.post(this.myAppUrl + 'api/master/AddItem', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  updateItem(data) {
    return this._http.put(this.myAppUrl + 'api/master/UpdateItem', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteItem(data) {
    return this._http.delete(this.myAppUrl + "api/master/DeleteItem/" + data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //** Term
  getTerms(isNotALL: Boolean) {
    return this._http.get(this.myAppUrl + 'api/master/GetListTerms/' + isNotALL, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getTermById(id: number) {
    return this._http.get(this.myAppUrl + 'api/master/GetTermById/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getTermsForDropDown() {
    return this._http.get(this.myAppUrl + 'api/master/GetListTermsForDropDown', {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addTerm(data) {
    return this._http.post(this.myAppUrl + 'api/master/AddTerm', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  updateTerm(data) {
    return this._http.put(this.myAppUrl + 'api/master/UpdateTerm', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteTerm(data) {
    return this._http.delete(this.myAppUrl + "api/master/DeleteTerm/" + data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


  //** CommissionPlan
  getCommissionPlans(isNotALL: Boolean) {
    return this._http.get(this.myAppUrl + 'api/master/GetListCommissionPlans/' + isNotALL, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getCommissionPlanById(id: number) {
    return this._http.get(this.myAppUrl + 'api/master/GetCommissionPlanById/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getCommissionPlansForDropDown() {
    return this._http.get(this.myAppUrl + 'api/master/GetListCommissionPlansForDropDown', {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addCommissionPlan(data) {
    return this._http.post(this.myAppUrl + 'api/master/AddCommissionPlan', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  updateCommissionPlan(data) {
    return this._http.put(this.myAppUrl + 'api/master/UpdateCommissionPlan', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteCommissionPlan(data) {
    return this._http.delete(this.myAppUrl + "api/master/DeleteCommissionPlan/" + data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
}  



// WEBPACK FOOTER //
// ./src/app/services/master-service.ts